exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(require("-!../../../node_modules/css-loader/index.js!vue-directive-tooltip/css/index.css"), "");

// module
exports.push([module.id, ".radio-label .mr-radio[data-v-5c47c60a] {\n  margin-right: 0.5em;\n}\n", ""]);

// exports
